<template>
    <ModalComponent
        name="addSancion"
        :title="'Nueva sanción para ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="row" @submit.prevent="submit">
            <div class="col-12">
                <FormInput label="Fecha de inicio" type="date" name="fecha_inicio" id="fecha_inicio" rules="required" v-model="fecha_inicio" />
            </div>
            <div class="col-12">
                <FormInput label="Fecha de fin" type="date" name="fecha_fin" id="fecha_fin" rules="required" v-model="fecha_fin" />
            </div>
            <div class="col-12 mt-3">
                <div class="form-group">
                    <label for="nombre">Motivo</label>
                    <CkEditorComponent v-model="motivo"/>
                </div>
            </div>
            <div class="col-12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox3" v-model="bloquear_acceso"/>
                    <label for="customCheckbox3" class="custom-control-label">Bloquear acceso</label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button type="submit" :disabled="loading">Sancionar</Button>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['abonado'],
        data() {
            return {
                fecha_inicio: null,
                fecha_fin: null,
                loading: false,
                bloquear_acceso: 0,
                motivo: null
            }
        },
        methods: {
            close(sancionado) {
                this.$emit('close', 'addSancion', sancionado);
            },
            sancionar() {
                this.loading = true;

                if(this.bloquear_acceso) {
                    this.bloquear_acceso = 1;
                } else {
                    this.bloquear_acceso = 0;
                }

                const params = {
                    id: this.abonado.id,
                    fecha_inicio: this.fecha_inicio,
                    fecha_fin: this.fecha_fin,
                    abonado_id: this.abonado.id,
                    bloquear_acceso: this.bloquear_acceso,
                    motivo: this.motivo
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.sancionar'), params).then(res => {
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.sancionar();
                }
            },
        },
        components: {
            ModalComponent,
            CkEditorComponent
        }
    }
</script>
